<template>
  <div class="home-view">
    <component :config="config" :is="currentComponent"></component>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      config: {},
    };
  },
  components: {
    webPage: () => import("./webPage.vue"),
    mPageBak: () => import("./mPage.vue"),
    mPage: () => import("./mPage.vue"), //新版小红书落地页
  },
  computed: {
    app_download_url() {
      if (
        Array.isArray(this.config.app_download_url) &&
        this.config.app_download_url.length > 0
      ) {
        return this.config.app_download_url[0].url;
      }
      return "";
    },
    currentComponent() {
      return this.isMobile() ? "mPageBak" : "webPage";
    },
  },
  methods: {
    isMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      console.log(
        /android|iphone|ipad|ipod|windows phone|blackberry|opera mini|iemobile|mobile/i.test(
          userAgent
        ),
        userAgent
      );
      return /android|iphone|ipad|ipod|windows phone|blackberry|opera mini|iemobile|mobile/i.test(
        userAgent
      );
    },
  },
  created() {},
};
</script>
<style scoped>
.home-view {
  width: 100%;
  height: 100%;
}
</style>
